const cartBackBtn = document.querySelector(".cart-back-btn");
if (cartBackBtn) {
  cartBackBtn.addEventListener("click", () => {
    window.history.back();
  });
}

/* ~~~~~~~~~~~~~~~element position change below 900px~~~~~~~~~~~~~~~~~~~~~ */
const dltBtns = document.querySelectorAll(".cart-product-delete");
const qtys = document.querySelectorAll(".cart-product-qty");
const cartFooterContainer = document.querySelectorAll(".cart-product-footer");

const orginalPositions = Array.from(dltBtns).map((btn) => ({
  parent: btn.parentNode,
  nextSibling: btn.nextSibling,
}));

const qtyOrginalPositions = Array.from(qtys).map((qty) => ({
  parent: qty.parentNode,
  nextSibling: qty.nextSibling,
}));

function positionChange(e) {
  if (e.matches) {
    cartFooterContainer.forEach((container, index) => {
      container.appendChild(dltBtns[index]);
      container.appendChild(qtys[index]);
    });
  } else {
    dltBtns.forEach((btn, i) => {
      const orginalPosition = orginalPositions[i];
      const { parent, nextSibling } = orginalPosition;
      if (nextSibling) {
        parent.insertBefore(btn, nextSibling);
      } else {
        parent.appendChild(btn);
      }
    });
    qtys.forEach((qty, i) => {
      const orginalPosition = qtyOrginalPositions[i];
      const { parent, nextSibling } = orginalPosition;
      if (nextSibling) {
        parent.insertBefore(qty, nextSibling);
      } else {
        parent.appendChild(qty);
      }
    });
  }
}

/* get media query */
const mediaQuery1 = window.matchMedia("(max-width: 900px)");

mediaQuery1.addEventListener("change", positionChange);

positionChange(mediaQuery1);

/* ~~~~~~~~~~~~~~~element position change below 480px~~~~~~~~~~~~~~~~~~~~~ */
const cartPrices = document.querySelectorAll(".cart-product-price");

const priceOrginalPositions = Array.from(cartPrices).map((price) => ({
  parent: price.parentNode,
  nextSibling: price.nextSibling,
}));

function positionChange2(e) {
  if (e.matches) {
    cartFooterContainer.forEach((container, index) => {
      container.appendChild(cartPrices[index]);
    });
  } else {
    cartPrices.forEach((price, i) => {
      const orginalPosition = priceOrginalPositions[i];
      const { parent, nextSibling } = orginalPosition;
      if (nextSibling) {
        parent.insertBefore(price, nextSibling);
      } else {
        parent.appendChild(price);
      }
    });
  }
}

const mediaQuery2 = window.matchMedia("(max-width: 480px)");

mediaQuery2.addEventListener("change", positionChange2);

positionChange2(mediaQuery2);

/* mobile view modal */
// const continueBtn = document.querySelector(".cart-continue");
// const cartRight = document.querySelector(".cart-right");
// const cartContainer = document.querySelector(".cart-right-container");
// continueBtn.addEventListener("click", () => {
// 	cartRight.classList.toggle("active");

// 	document.body.style.overflow = "hidden";
// });

// cartRight.addEventListener("click", (e) => {
// 	if (!cartContainer.contains(e.target)) {
// 		cartRight.classList.remove("active");
// 		document.body.style.overflow = "";
// 	}
// });

/* update cart products, qty, delete */
function updateCartQuantity(lineId, quantity) {
  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      updates: {
        [lineId]: quantity,
      },
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      // console.log(data);
      updateCartUI(data);
    })
    .catch((error) => {
      console.error("Error updating cart quantity:", error);
    });
}

// Function to delete a product from the cart
function deleteCartItem(lineId) {
  fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: lineId,
      quantity: 0,
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      // console.log(data);
      const productCard = document.querySelector(`[data-line-id="${lineId}"]`);
      if (productCard) {
        productCard.remove();
      }
      // Optionally, update the cart UI with the new total, item count, etc.
      updateCartUI(data);
    })
    .catch((error) => {
      console.error("Error deleting cart item:", error);
    });
}

function formatMoney(amount) {
  return new Intl.NumberFormat("en-AE", {
    style: "currency",
    currency: "AED", // Use 'AED' for UAE Dirham
    minimumFractionDigits: 2, // Ensure two decimal places
    maximumFractionDigits: 2,
  }).format(amount / 100); // Shopify's prices are in cents, so divide by 100
}

// Function to update the cart UI after changes (quantity update or deletion)
function updateCartUI(data) {
  // console.log(data);
  if (data.items.length == 0) {
    window.location.reload();
  }
  data.items.forEach((item) => {
    const productCard = document.querySelector(`[data-line-id="${item.id}"]`);

    if (productCard) {
      // Update the individual item price (price * quantity)
      const itemPriceElement = productCard.querySelector(
        ".cart-final-line-price"
      );
      if (itemPriceElement) {
        itemPriceElement.innerText = formatMoney(item.line_price);
      }

      // // Update the quantity
      // const quantityElement = productCard.querySelector(
      // 	".cart-product-quantity"
      // );
      // if (quantityElement) {
      // 	quantityElement.innerText = item.quantity;
      // }
    }
  });

  // update subtotal parice
  const subtotalPriceElement = document.querySelector(".cart-subtotal-price");
  if (subtotalPriceElement) {
    subtotalPriceElement.innerText = formatMoney(data.items_subtotal_price); // Format as required
  }

  // Update the total price including taxes
  const totalPriceElementIncl = document.querySelector(
    ".cart-total-price-incl"
  );
  if (totalPriceElementIncl) {
    totalPriceElementIncl.innerText = formatMoney(data.total_price); // Format as required
  }
  // Update the total price
  const totalPriceElement = document.querySelector(".cart-total-price");
  if (totalPriceElement) {
    totalPriceElement.innerText = formatMoney(data.total_price); // Format as required
  }

  // Update the total item count
  const itemCountElement = document.querySelector(".cart-item-count"); // Assuming you have a cart-item-count element
  if (itemCountElement) {
    itemCountElement.innerText = data.item_count;
  }

  // update nav bar cart count
  const navBarCartAnime = document.querySelector(".cart-anim-container span");
  if (navBarCartAnime) {
    navBarCartAnime.innerText = data.item_count;
  }
  const navBarCartCount = document.querySelector(".cart-count");
  if (navBarCartCount) {
    navBarCartCount.innerText = data.item_count;
  }
}

// Add event listeners for quantity changes and delete button
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".cart-product").forEach((product) => {
    const lineId = product.getAttribute("data-line-id");

    // Handle quantity decrease
    if (product.querySelector(".qty-decrease")) {
      product.querySelector(".qty-decrease").addEventListener("click", () => {
        let quantity = parseInt(
          product.querySelector(".cart-product-quantity").innerText
        );
        if (quantity > 1) {
          quantity--;
          product.querySelector(".cart-product-quantity").innerText = quantity;
          updateCartQuantity(lineId, quantity);
        }
      });
    }

    // Handle quantity increase
    if (product.querySelector(".qty-increase")) {
      product.querySelector(".qty-increase").addEventListener("click", () => {
        let quantity = parseInt(
          product.querySelector(".cart-product-quantity").innerText
        );
        quantity++;
        product.querySelector(".cart-product-quantity").innerText = quantity;
        updateCartQuantity(lineId, quantity);
      });
    }

    // Handle delete button
    if (product.querySelector(".delete-product")) {
      product.querySelector(".delete-product").addEventListener("click", () => {
        product.querySelector(".loader").classList.remove("hidden");
        deleteCartItem(lineId);
      });
    }
  });
});
